<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="90%"
      :wrapperClosable="false"
    >
      <div class="div-top" style="margin-top: 10px; padding: 0 10px">
        <el-date-picker
          v-model="searchData.YearMonth"
          type="monthrange"
          value-format="yyyyMM"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
        >
        </el-date-picker>
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <div class="form-center" v-loading="loading">
        <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
          <el-tab-pane label="能耗" name="能耗"></el-tab-pane>
          <el-tab-pane label="备件" name="备件"></el-tab-pane>
          <el-tab-pane label="外委" name="外委"></el-tab-pane>
          <el-tab-pane label="折旧" name="折旧"></el-tab-pane>
        </el-tabs>
        <el-table
          :key="activeName"
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 85px)"
        >
          <el-table-column
            label="设备分类"
            align="center"
            prop="DeviceTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备编号"
            align="center"
            prop="DeviceCode"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="设备名称"
            align="center"
            prop="DeviceName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="年月"
            align="center"
            prop="iYearMonth"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="Position"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="能耗(耗用量/金额)"
            align="center"
            v-if="activeName === '能耗'"
          >
            <el-table-column
              label="电"
              align="right"
              prop="ElectricityAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.ElectricityQty || 0 }} /
                {{ $tools.momenyFormat(scope.row.ElectricityAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="水"
              align="right"
              prop="WaterAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.WaterQty || 0 }} /
                {{ $tools.momenyFormat(scope.row.WaterAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column label="气" align="right" prop="GasAmount" sortable>
              <template slot-scope="scope">
                {{ scope.row.GasQty || 0 }} /
                {{ $tools.momenyFormat(scope.row.GasAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column label="油" align="right" prop="GasAmount" sortable>
              <template slot-scope="scope">
                {{ scope.row.OilQty || 0 }} /
                {{ $tools.momenyFormat(scope.row.OilAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="小计"
              align="right"
              prop="SubTotal"
              sortable
            >
              <template slot-scope="scope">
                {{ scope.row.SubQty || 0 }} /
                {{ $tools.momenyFormat(scope.row.SubTotal, 2) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="摊销后金额"
            align="right"
            prop="AmortizationAmount"
            sortable
            v-if="activeName === '备件'"
          >
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.AmortizationAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
            label="外委维修"
            align="right"
            prop="OutsourcingAmount"
            sortable
            v-if="activeName === '外委'"
          >
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.OutsourcingAmount, 2) }}
            </template>
          </el-table-column>
          <el-table-column
            label="折旧"
            align="right"
            prop="DeviceDepreciationAmount"
            sortable
            v-if="activeName === '折旧'"
          >
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.DeviceDepreciationAmount, 2) }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="成本总计"
            align="right"
            prop="ToTalAmount"
            sortable
          >
            <template slot-scope="scope">
              {{ $tools.momenyFormat(scope.row.ToTalAmount, 2) }}
            </template>
          </el-table-column> -->
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      moment,
      searchData: {
        YearMonth: [],
      },
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      title: '',
      loading: false,

      RoleList: [],
      tableData: [],

      drawer: false,
      disabled: false,
      row: {},
      activeName: '能耗',
    }
  },
  props: {},
  components: {},
  methods: {
    handleTabClick(tab, event) {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$nextTick(() => {
          this.$refs.dialogTable.doLayout()
        })
      }, 300)
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      this.row = row

      this.tableData = []

      this.title = title
      this.searchData.YearMonth = [
        moment().format('YYYYMM'),
        moment().format('YYYYMM'),
      ]
      this.activeName = '能耗'
      this.pagination.PageIndex = 1
      this.pagination.PageRows = 20
      this.pagination.total = 0
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device/GetDeviceCostDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'Id',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'isYearMonth',
              Keyword: this.searchData.YearMonth
                ? this.searchData.YearMonth[0]
                : '', //开始月份,
            },
            {
              Condition: 'ieYearMonth',
              Keyword: this.searchData.YearMonth
                ? this.searchData.YearMonth[1]
                : '', //,
            },
            {
              Condition: 'Id',
              Keyword: this.row.Id || '',
            },
            // Condition: "Id", //设备id
            // Keyword: this.row.Id,
            // isYearMonth: this.searchData.YearMonth ? this.searchData.YearMonth[0] : "", //开始月份
            // ieYearMonth: this.searchData.YearMonth ? this.searchData.YearMonth[1] : "", //结束月份
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 160px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
::v-deep .el-table {
  th {
    background-color: #f5f7fa;
  }
}
</style>
